import api from '@/api'
/* eslint-disable global-require */

const state = {
  leaders: null,
}

const FIND_LEADERS = 'FIND_LEADERS'

const actions = {
  async findLeaders({ commit }) {
    const { leaders } = await api.about.findLeaders()
    commit(FIND_LEADERS, { leaders })
  },
}

const mutations = {
  FIND_LEADERS(state, { leaders }) {
    state.leaders = leaders
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/about.js